const columns = [
  {
    key: "deviceCode",
    zh: "整机编号",
    en: "Device Code",
    width: "14%"
  },
  {
    key: "company",
    zh: "公司名称",
    en: "Company",
    width: "20%"
  },
  {
    key: "model",
    zh: "机型",
    en: 'Model',
    width: "10%"
  },
  {
    key: "conversionRatedPower",
    zh: "换算后额定功率(kw)",
    en: "Conversion Rated Power(kw)",
    width: "27%"
  },
  {
    key: "ratedPower",
    zh: "额定功率(kw)",
    en: "Rated Power(kw)",
    width: "18%"
  },
  {
    key: "percentage",
    zh: "堵塞率",
    en: "Percentage",
    width: "11%"
  }
]

export default columns